<!--
  @Description: 英文版月报
  @Author: wang.y 
  @Date: 2025-11-19 
-->
<template>
  <div class="santen-container index">
    <div class="header">
      <div class="middle">
        <img :src="customReportDto.logoPath | logo_show" class="logo-img">
        <ul class="nav">
          <li :class="{active: currentModuleId === ''}">
            <a @click="haddleModelSlider('')">Index</a>
          </li>
          <li v-for="item,index in moduleList" :key="index" :class="{active: currentModuleId === item.id}">
            <a @click="haddleModelSlider(item.id)">{{item.enName}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="banner">
      <div class="banner-bg">
        <img :src="static_img_url + 'pic/newsletter/santen-bg.png?v=31'" v-if="$route.query.name == 'santen'">
        <img :src="static_img_url + 'pic/newsletter/common-bg.png?v=31'" v-else>
      </div>
      <div class="banner-content">
        <div style="height: 100px" v-if="$route.query.name == 'santen'"></div>
        <img :src="customReportDto.logoPath | logo_show" class="logo-img" v-else>
        <div class="title">{{customReportDto.enTitle}}</div>
        <Select v-model="currentChapterId" class="chapter-sel" @on-change="haddleChangeChapter">
          <Option v-for="item in chapterDtoList" :value="item.id" :key="item.id">No.{{item.num}} {{item.enTitle}}</Option>
        </Select>
        <div class="search-ipt">
          <i class="iconfont search-icon">&#xe6d7;</i>
          <Input v-model="searchKeyword" @on-enter="handleSearch" placeholder="Search title, content, entity, policy, indication" />
          <Button @click="handleSearch">Search</Button>
        </div>
        <Button class="download-btn" @click="handleDownLoad">Export</Button>
      </div>
    </div>
    <div class="content">
      <ul class="number-new">
        <li v-for="item,index in moduleList" :key="index" :class="['number-item-light', item.id == 13 && 'blue']" @click="haddleModelSlider(item.id)">
          <div class="number-l">
            <p class="number_name">{{item.enName}}</p>
            <p class="number-line"></p>
          </div>
          <div class="number-r">
            <span class="count">{{moduleContents[item.id].length}}</span>
            <i class="iconfont">&#xe647;</i>
          </div>
        </li>
      </ul>
      <div class="summary">
        <p class="tle">Current Summary</p>
        <div>
          <div v-html="currentChapterDto.enSummary"></div>
        </div>
      </div>
      <div class="temps">
        <div class="temp" v-for="item,index in moduleList" :key="index" :id="'tempLi' + item.id">
          <div class="temp-content">
            <div class="tle">
              <img :src="static_img_url + 'pic/briefReport/icon_l.png'">
              <span>{{item.enName}}</span>
              <img :src="static_img_url + 'pic/briefReport/icon_r.png'">
            </div>
            <ul class="content-list" v-if="moduleContents[item.id].length">
              <li v-for="secItem,topicIndex in moduleContents[item.id]" :key="topicIndex" v-show="topicIndex < 10 || showAll[item.id]">
                <div class="topic" v-if="secItem.contentType === 0">
                  <div class="title">
                    <img :src="static_img_url + 'pic/briefReport/slash.png'" class="slash">
                    <a :href="secItem.srcUrl" target="_blank">{{secItem.enTitle}}</a>
                  </div>
                  <div class="desc" v-html="secItem.enContent"></div>
                </div>
                <div class="report" v-if="secItem.contentType === 2">
                  <a class="image" :href="secItem.srcUrl" target="_blank">
                    <img :src="secItem.logoPath | logo_show" />
                  </a>
                  <div class="card">
                    <div class="card-top">
                      <a :href="secItem.srcUrl" target="_blank" class="title">{{secItem.enTitle}}</a>
                      <div class="desc" v-html="secItem.enContent"></div>
                    </div>
                    <div class="card-btm">
                      <span v-if="secItem.srcAuthor"><i class="iconfont">&#xe645;</i>来源：{{secItem.srcAuthor}}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="temp-bottom" v-if="moduleContents[item.id].length > 10">
              <span class="more-btn" @click="showAllList(item.id)">
                {{!showAll[item.id] ? 'Expand' : 'Hide' }} All
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop></BackTop>
    <DownloadModal ref="download-modal" :chapterList="chapterDtoList" :detailTitle="customReportDto.enTitle"></DownloadModal>
  </div>
</template>
<script>
import { addPuv, AchapterInfo, AchapterModuleContentList, AchapterModuleList } from '@/service'
import filter from 'js/filter'
import moment from 'moment'
import { mapState } from 'vuex'
import DownloadModal from './components/EnDownloadModal'
export default {
  components: {
    DownloadModal,
  },
  created() {
    if (this.$route.query.uid && this.$route.query.name) {
      this.getDetail()
    } else {
      this.$Message.error('Invalid URL parameter!')
      this.$router.push({ path: '/no' })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      filter,
      loading: true,

      chapterDtoList: [],
      customReportDto: {},
      moduleList: [],
      moduleContents: {},

      chapterParams: {
        chapterIds: [],
        keyword: '',
        moduleIds: [],
        startTime: '',
        endTime: '',
        getCount: false,
        page: 1,
        size: 99999,
        topCreateTime: null,
      },

      currentModuleId: '',

      currentChapterId: '',
      currentChapterDto: {},

      searchKeyword: '',
      showAll: {},

      tempTopArr: [],
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      static_img_url: (state) => state.static_img_url,
      img_req_url: (state) => state.img_req_url,
    }),
    reportPath() {
      return function (path) {
        const protocol = window.location.protocol
        return `${protocol}//static-cdn.vcbeat.top/pdf/web/viewer-d8.html?file=${this.img_req_url}${path}`
      }
    },
  },
  methods: {
    /**
     * 获取月报英文基本信息及期刊
     */
    async getDetail() {
      let res = await AchapterInfo(
        {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
        },
        (error) => this.$Message.error('Request Error!')
      )
      if (res.code === 0) {
        if (res.data.customReportDtoList.length) {
          this.$set(this.$data, 'customReportDto', res.data.customReportDtoList[0])
        }
        if (res.data.chapterDtoList.length) {
          this.$set(this.$data, 'chapterDtoList', res.data.chapterDtoList)

          if (this.$route.query.chapter) {
            const targetChapter = res.data.chapterDtoList.find(
              (item) => item.id == this.$route.query.chapter
            )
            this.currentChapterDto = targetChapter || res.data.chapterDtoList[0]
          } else {
            this.currentChapterDto = res.data.chapterDtoList[0]
          }
          this.currentChapterId = this.currentChapterDto.id
          this.getModuleList()
        }
        this.getAddPuv()
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    /**
     * 统计
     */
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.customReportDto.id,
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('Request Error!'))
    },
    /**
     * 获取月报英文期刊的模块列表
     */
    async getModuleList() {
      let res = await AchapterModuleList(
        {
          chapterIds: [this.currentChapterId],
        },
        (error) => this.$Message.error('Request Error!')
      )
      if (res.code === 0) {
        this.$set(this.$data, 'moduleList', res.data.moduleList)
        this.moduleList.forEach((item) => {
          this.$set(this.moduleContents, item.id, [])
          this.$set(this.showAll, item.id, false)
        })
        this.chapterParams.chapterIds = [this.currentChapterId]
        this.getModuleContentList()
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    /**
     * 获取月报英文期刊的模块内容列表
     */
    async getModuleContentList() {
      let res = await AchapterModuleContentList(this.chapterParams, (error) =>
        this.$Message.error('Request Error!')
      )
      this.loading = false
      if (res.code === 0) {
        res.data.contentDtos.forEach((item) => {
          this.moduleContents[item.moduleId].push(item)
        })
      } else {
        this.$Message.error(res.enMsg)
      }
    },
    showAllList(moduleId) {
      this.showAll[moduleId] = !this.showAll[moduleId]
      this.$forceUpdate()
    },
    /**
     * 切换期刊
     */
    haddleChangeChapter(value) {
      const index = this.chapterDtoList.findIndex((a) => a.id == value)
      this.currentChapterDto = this.chapterDtoList[index]
      this.getModuleList()
    },
    /**
     * 导航点击事件
     * item 点击的对象
     */
    haddleModelSlider(moduleId) {
      let targetTop
      if (moduleId === '') {
        targetTop = 0
      } else {
        targetTop = $('#tempLi' + moduleId).offset().top - 68
      }
      $('html, body').animate({ scrollTop: targetTop }, 200)
    },
    /**
     * 监听滚动条改变
     * 导航高亮
     */
    handleScroll() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
      this.tempTopArr = []
      this.moduleList.map((a) => {
        this.tempTopArr.push({
          moduleId: a.id,
          offsetTop: $('#tempLi' + a.id).offset().top - 78,
        })
      })
      this.tempTopArr = [
        ...this.tempTopArr,
        ...[
          {
            moduleId: '',
            offsetTop: 0,
          },
        ],
      ]
      this.tempTopArr.sort((a, b) => a.offsetTop - b.offsetTop)
      for (let i = 0; i < this.tempTopArr.length; i++) {
        if (this.scrollTop >= this.tempTopArr[i].offsetTop) {
          this.currentModuleId = this.tempTopArr[i].moduleId
        }
      }
      this.$forceUpdate()
    },
    handleDownLoad() {
      this.$refs['download-modal'].show(this.chapterParams.chapterIds)
    },
    handleSearch() {
      if (!this.searchKeyword) {
        this.$Message.error('Please enter search content!')
        return
      }
      const encodedKeyword = encodeURIComponent(this.searchKeyword)
      this.$router.push({
        name: 'EnSearchNewsletter',
        query: { ...this.$route.query, ...{ keyword: encodedKeyword } },
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import './style/santen.stylus'
ellipsisClamp(clamp)
  display -webkit-box
  overflow hidden
  text-overflow ellipsis
  word-break break-all
  -webkit-box-orient vertical
  -webkit-line-clamp clamp
.santen-container
  .logo-img
    max-width 200px !important
    max-height 40px !important
    width auto
    height auto
  .number-new
    li
      width 220px
  .banner
    &-content
      top 120px
  .inno
    height 164px
    display flex
    align-items center
    justify-content center
    im
      width 30px
      height 30px
    p
      font-size 14px
      color #A5B4E6
      margin-left 18px
.index
  >>> .ivu-back-top-inner
    background-color #fff
    i
      color #999
    &:hover
      i
        color #FA5A00
</style>